<div>
    <button mat-raised-button color="primary" (click)="DownloadCalendarPDF($event)">
        DownloadCalendarPDF
    </button>
</div>